namespace Matrix.Workflow {
    export interface ClientFunctionTriggerForm {
        TriggerCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        FunctionName: FormatLookupEditor;
        NavigationPath: Serenity.StringEditor;
        Permission: Serenity.StringEditor;
        ParameterList: ClientFunctionTriggerParametersEditor;
        ActionVerb: Serenity.StringEditor;
        DisplayOrder: Serenity.IntegerEditor;
        Icon: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ClientFunctionTriggerForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.ClientFunctionTrigger';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ClientFunctionTriggerForm.init)  {
                ClientFunctionTriggerForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = ClientFunctionTriggerParametersEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(ClientFunctionTriggerForm, [
                    'TriggerCode', w0,
                    'Description', w0,
                    'FunctionName', w1,
                    'NavigationPath', w0,
                    'Permission', w0,
                    'ParameterList', w2,
                    'ActionVerb', w0,
                    'DisplayOrder', w3,
                    'Icon', w0,
                    'IsActive', w4,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
